const DraggableItemTypes = {
  Sticker: "draggable_sticker",
};

export default DraggableItemTypes;
